module.exports = "/assets/dist/img/cart.svg?ce988caeec172fc7fa4d842351d93a3e";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/grad-images/site-header/svg/cart.svg
// module id = 1774
// module chunks = 26